import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CurrencyDTO, NewOperationalFileExchangeRateDTO } from "../../../core/services/swagger-gen/fordesk";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DecimalFormatterService } from "../../../core/helpers/decimal-formatter.service";

export interface AddNewExchangeRateData {
  currencyFrom: CurrencyDTO;
  operationalFileCurrency: CurrencyDTO;
  exchangeRate: number;
}

@Component({
  selector: 'add-exchange-rate-dialog',
  templateUrl: './add-exchange-rate-dialog.component.html',
  styleUrls: ['./add-exchange-rate-dialog.component.scss']
})
export class AddExchangeRateDialogComponent implements OnInit {

  public calculatedCourseAmount: number;
  public form: FormGroup | null
  constructor(private dialogRef: MatDialogRef<AddExchangeRateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddNewExchangeRateData,
    private fb: FormBuilder,
    public formatService: DecimalFormatterService,
  ) {
  }

  public ngOnInit(): void {
    this.form = this.fb.group({
      exchangeRate: [this.data.exchangeRate ?? 1, [Validators.required, Validators.min(0.1)]],
    });

    this.form.controls.exchangeRate.valueChanges.pipe().subscribe(value => {
      this.calculatedCourseAmount = this.calculateExchangeRateFromAmount(value, 1);
    });
  }

  public cancel() {
    this.dialogRef.close(null);
  }

  public submitted: boolean = false;

  public save() {
    if (!this.form.valid) {
      this.submitted = true;
      return;
    }

    let newExchangeRate: NewOperationalFileExchangeRateDTO = {
      currencyFromId: this.data.currencyFrom.id,
      currencyToId: this.data.operationalFileCurrency.id,
      exchangeRate: this.form.controls.exchangeRate.value
    }

    this.dialogRef.close(newExchangeRate);
  }

  private calculateExchangeRateFromAmount(exchangeRate: number, amount: number) {
    if (!exchangeRate || exchangeRate === 0) {
      return amount;
    }
    const result = exchangeRate * amount;

    return parseFloat(parseFloat(result.toString()).toPrecision(15));
  }
}
